import { Save, Trash2 } from "lucide-react";
import type { DemoPreview } from "@/src/features/demo-contracts/types";

export function ActionsSection({
  preview: _preview,
}: {
  preview: DemoPreview;
}) {
  return (
    <>
      <section className="space-y-2 rounded-xl border border-white/10 bg-white/[0.03] p-4">
        <h3 className="text-[11px] font-semibold uppercase tracking-widest text-primary-foreground/55">
          Save this report
        </h3>
        <p className="text-[11px] leading-relaxed text-primary-foreground/68">
          This action will eventually let you keep a report in your workspace
          and return to it later.
        </p>
        <button
          type="button"
          disabled
          aria-disabled="true"
          title="Save report is coming soon"
          className="inline-flex items-center gap-1.5 rounded-md border border-white/15 bg-white/5 px-3 py-1.5 text-[11px] font-semibold text-primary-foreground/35"
        >
          <Save className="size-3.5" aria-hidden="true" />
          Save report
        </button>
      </section>

      <section className="space-y-2 rounded-xl border border-white/10 bg-black/15 p-4">
        <h3 className="text-[11px] font-semibold uppercase tracking-widest text-primary-foreground/60">
          Remove this report
        </h3>
        <p className="text-[11px] leading-relaxed text-primary-foreground/62">
          Removal stays disabled in demo mode so you can inspect the experience
          without losing the preview state.
        </p>
        <button
          type="button"
          disabled
          aria-disabled="true"
          title="Delete report is coming soon"
          className="inline-flex items-center gap-1.5 rounded-md border border-white/10 bg-white/5 px-3 py-1.5 text-[11px] font-semibold text-primary-foreground/35"
        >
          <Trash2 className="size-3.5" aria-hidden="true" />
          Delete report
        </button>
      </section>
    </>
  );
}
